import { BaseService } from "./BaseService";

export class RoleService extends BaseService {
  constructor() {
    super("/admin/roles");
  }

  async find(params = {}) {
    try {
      const response = await this.getClient().get("/admin/roles", { params });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getPermissions() {
    try {
      const response = await this.getClient().get("/admin/roles/permissions");
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async findOne(id) {
    try {
      const response = await this.getClient().get(`/admin/roles/${id}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async create(data) {
    try {
      const response = await this.getClient().post("/admin/roles", data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async update(id, data) {
    try {
      const response = await this.getClient().put(`/admin/roles/${id}`, data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async delete(id) {
    try {
      const response = await this.getClient().delete(`/admin/roles/${id}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async createPermission(data) {
    try {
      const response = await this.getClient().post("/admin/roles/permissions", data);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async deletePermission(id) {
    try {
      const response = await this.getClient().delete(`/admin/roles/permissions/${id}`);
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
